<template>
  <div class="reserve">
    <img src="/static/img/reserve/reserve01.png"
         alt=""
         class=""
         width="1190px">
    <ul class="reserve-menu">
      <!-- <li class="demand" @click="jump('spareRequirementsList')">备件需求</li>
      <li @click="jump('sparePartsLibrary')">备件库查询</li>
      <li @click="jump('spareGetList')">备件领用</li>
      <li @click="jump('spareStatementList')">我的对账单</li> -->
      <li @click="jump('spareRequirementsList')"
          class="spareRequirementsList">
        <!-- <img src="/static/img/reserve/spareRequirementsList.png" alt="备件需求"> -->
      </li>
      <li @click="jump('sparePartsLibrary')"
          class="sparePartsLibrary"></li>
      <li @click="jump('spareGetList')"
          class="spareGetList"></li>
      <li @click="jump('spareStatementList')"
          class="spareStatementList"></li>
    </ul>
    <img src="/static/img/reserve/reserve02.png"
         alt=""
         class=""
         width="1190px">
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    jump (name) {
      if (this.$getAccessToken()) {
        this.$router.push({ name: name })
      } else {
        this.$router.push({ name: 'login' })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.reserve {
  width: 1190px;
  margin: 0 auto;
  .reserve-menu {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    > li {
      // background-color: #1e64a9;
      // color: #fff;
      // border-radius: 20px;
      // line-height: 40px;
      // // padding: 5px 10px 5px 30px;
      // padding-left: 50px;
      // min-width: 150px;
      cursor: pointer;
      width: 265px;
      height: 101px;
    }
    .spareRequirementsList {
      background: url("/static/img/reserve/spareRequirementsList.png") no-repeat;
      &:hover {
        background-image: url("/static/img/reserve/spareRequirementsList-over.png");
      }
    }
    .sparePartsLibrary {
      background: url("/static/img/reserve/sparePartsLibrary.png") no-repeat;
      &:hover {
        background-image: url("/static/img/reserve/sparePartsLibrary-over.png");
      }
    }
    .spareGetList {
      background: url("/static/img/reserve/spareGetList.png") no-repeat;
      &:hover {
        background-image: url("/static/img/reserve/spareGetList-over.png");
      }
    }
    .spareStatementList {
      background: url("/static/img/reserve/spareStatementList.png") no-repeat;
      &:hover {
        background-image: url("/static/img/reserve/spareStatementList-over.png");
      }
    }
    // .demand{
    //   background-image: url('/static/img/add.png');
    //   // background-position: center center;
    //   background-size: 40px 40px;
    //   background-repeat: no-repeat;
    // }
  }
}
</style>
